module.exports = __webpack_public_path__ + "47e3c6c3ab78bfd23c20b13212811a4b.GIF";